<ng-container *ngIf="!isLoading">

    <ng-container *ngFor="let report of reportNotis">
        <div fxFlex="0 1 auto" class="alert-card mat-elevation-z3 m-12 mr-20 p-12">
    
            <div fxLayout="row" fxLayoutAlign="space-between center" class="font-size-12 secondary-text">
                <ng-container [ngSwitch]="report.reportTypeId">
                    <span *ngSwitchCase="reportTypes.ReportComplaint" fxLayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon class="mr-8">flag</mat-icon> {{'REPORT-PANEL.TYPE.ReportComplaint' | translate}}</span>
    
                    <span *ngSwitchCase="reportTypes.ReportAlert" fxLayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon class="mr-8">warning_amber</mat-icon> {{'REPORT-PANEL.TYPE.ReportAlert' | translate}}</span>
    
                    <span *ngSwitchCase="reportTypes.ReportCase" fxLayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon class="mr-8">assignment_ind</mat-icon> {{'REPORT-PANEL.TYPE.ReportCase' | translate}}</span>

                    <span *ngSwitchCase="reportTypes.FlatReportComplaint" fxLayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon class="mr-8">flag</mat-icon> {{'REPORT-PANEL.TYPE.FlatReportComplaint' | translate}}</span>
    
                    <span *ngSwitchCase="reportTypes.FlatReportAlert" fxLayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon class="mr-8">warning_amber</mat-icon> {{'REPORT-PANEL.TYPE.FlatReportAlert' | translate}}</span>
    
                    <span *ngSwitchCase="reportTypes.FlatReportCase" fxLayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon class="mr-8">assignment_ind</mat-icon> {{'REPORT-PANEL.TYPE.FlatReportCase' | translate}}</span>
                </ng-container>

                <div fxFlex="60" fxLayout="row" fxLayoutAlign="flex-end center">
                    <span>{{report.requestedDate | date:'yyyy-MM-dd HH:mm'}}</span>
                </div>
            </div>

            <mat-divider class="my-12"></mat-divider>
    
            <div fxLayout="row wrap" fxLayoutAlign="flex-start center" class="">
                <div fxFlex="100%">
                    <span fxFlex="50%" class="font-size-10 mb-4 secondary-text">{{'REPORT-PANEL.STATUS.TITLE'| translate}}</span>
                    <span fxFlex="50%" *ngIf="report.requestedParameters" class="font-size-10 mb-4 secondary-text pr-16">{{'REPORTS.PARAMETERS'| translate}}</span>
                </div>

                <ng-container [ngSwitch]="report.statusId">
                    <span *ngSwitchCase="reportStatuses.Pending" class="font-size-14 ml-4 py-4 px-16 alert-text pending">
                        {{'REPORT-PANEL.STATUS.Pending' | translate}}</span>
    
                    <span *ngSwitchCase="reportStatuses.InProcess" class="font-size-14 ml-4 py-4 px-16 alert-text process">
                        {{'REPORT-PANEL.STATUS.InProcess' | translate}}</span>
    
                    <span *ngSwitchCase="reportStatuses.Processed" class="font-size-14 ml-4 py-4 px-16 alert-text success">
                        {{'REPORT-PANEL.STATUS.Processed' | translate}}</span>
    
                    <span *ngSwitchCase="reportStatuses.Error" class="font-size-14 ml-4 py-4 px-16 alert-text warn">
                        {{'REPORT-PANEL.STATUS.Error' | translate}}</span>
                </ng-container>

                <div fxFlex="60%" align="end">
                    <ng-container *ngIf="report.requestedParameters">
                        <button mat-icon-button color="accent"
                            matTooltip="{{'REPORTS.PARAMETERS' | translate}}"
                            (click)="showReportParameters(report.requestedParameters)">
                            <mat-icon
                                class="font-size-28"
                                matBadge="{{checkMimeTypeLength(report.fileResult, mimeTypes.PDF).length}}"
                                matBadgeOverlap="true"
                                matBadgePosition="below"
                                matBadgeColor="primary"
                                matBadgeHidden="{{checkMimeTypeLength(report.fileResult, mimeTypes.PDF).length == 1}}">
                                list_alt</mat-icon>
                        </button>
                    </ng-container>
                </div>
            </div>

            <ng-container *ngIf="report.fileResult.length > 0"> <!--report.statusId !== reportStatuses.Processed && -->

                <mat-divider class="my-12"></mat-divider>

                <div fxLayout="row" fxLayoutAlign="space-between flex-start" class="">

                    <span class="font-size-10 secondary-text">{{'REPORT-PANEL.FILES'| translate}}</span>

                    <div fxLayout="row wrap" fxLayoutAlign="flex-end center">

                        <ng-container *ngIf="checkMimeTypeLength(report.fileResult, mimeTypes.PDF).length">
                            <button mat-icon-button color="accent" aria-label="Download report" class="mr-8" 
                                matTooltip="{{'REPORT-PANEL.DOWNLOAD' | translate}} - {{'REPORT-PANEL.FILES-REPORT' | translate:{mime: mimeTypesNames.PDF} }}"
                                (click)="getReportFiles(report.id, report.fileResult, mimeTypes.PDF)">
                                <mat-icon
                                    class="font-size-28"
                                    matBadge="{{checkMimeTypeLength(report.fileResult, mimeTypes.PDF).length}}"
                                    matBadgeOverlap="true"
                                    matBadgePosition="below"
                                    matBadgeColor="primary"
                                    matBadgeHidden="{{checkMimeTypeLength(report.fileResult, mimeTypes.PDF).length == 1}}">
                                    picture_as_pdf</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="checkMimeTypeLength(report.fileResult, mimeTypes.ZIP).length">
                            <button mat-icon-button color="accent" aria-label="Download report" class="mr-8" 
                                matTooltip="{{'REPORT-PANEL.DOWNLOAD' | translate}} - {{'REPORT-PANEL.FILES-REPORT' | translate:{mime: mimeTypesNames.ZIP} }}"
                                (click)="getReportFiles(report.id, report.fileResult, mimeTypes.ZIP)">
                                <mat-icon
                                    class="font-size-28"
                                    matBadge="{{checkMimeTypeLength(report.fileResult, mimeTypes.ZIP).length}}"
                                    matBadgeOverlap="true"
                                    matBadgePosition="below"
                                    matBadgeColor="primary"
                                    matBadgeHidden="{{checkMimeTypeLength(report.fileResult, mimeTypes.ZIP).length == 1}}">
                                    folder_zip</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="checkMimeTypeLength(report.fileResult).length">
                            <button mat-icon-button color="accent" aria-label="Download report" class="mr-8" 
                                matTooltip="{{'REPORT-PANEL.DOWNLOAD' | translate}} - {{'REPORT-PANEL.OTHER-FILES' | translate}}"
                                (click)="getReportFiles(report.id, report.fileResult)">
                                <mat-icon
                                    class="font-size-28"
                                    matBadge="{{checkMimeTypeLength(report.fileResult).length}}"
                                    matBadgeOverlap="true"
                                    matBadgePosition="below"
                                    matBadgeColor="primary"
                                    matBadgeHidden="{{checkMimeTypeLength(report.fileResult).length == 1}}">
                                    description</mat-icon>
                            </button>
                        </ng-container>

                    </div>

                </div>

            </ng-container>
    
        </div>
    </ng-container>
    
    <fade-in-animation *ngIf="!reportNotis || !reportNotis.length">
        <no-data-card [panel]="panelNames.reportPanel" class="m-12 mr-20"></no-data-card>
    </fade-in-animation>
    
</ng-container>

<fading-loading-animation *ngIf="isLoading">
    <striped-bars-card class="m-12 mr-20"></striped-bars-card>
    <striped-bars-card class="m-12 mr-20"></striped-bars-card>
    <striped-bars-card class="m-12 mr-20"></striped-bars-card>
</fading-loading-animation>
